import React, { useEffect, useMemo, useState } from 'react';
import ReactLoading from 'react-loading';
import { useNavigate, useParams } from 'react-router-dom';
import BackIcon from '../../../assets/icons/trvto_ArrowBack.svg';
import GuidHeaderDetails from './guidHeaderDetails/GuidHeaderDetails';
import DetailsImageDisplay from '../../../components/detailsImageDisplay/DetailsImageDisplay';
import DetailsTab from '../../../components/orgDetails/detailsTab/DetailsTab';
import OrgDateTab from '../../../components/orgDetails/orgDateTab/OrgDateTab';
import styles from './orgGuidTripDetails.module.css';
import { fetchOrgGuideDetails } from './orgGuideDetailsFn/orgGuideDetailsFn';
import { orgAddTimeSlot, orgGuideUnavailableDateFun } from '../../../api/orgGuidAPI';
import { toast } from 'react-toastify';
import errorHandle from '../../../utils/errorHandle';
import OrgSlotTab from '../../supOrgTripDetails/supOrgActivityDetails/actSlotAdd/ActSlotTab';

const OrgGuidDetails = () => {
    const navigate = useNavigate();
    const { guideId, mode } = useParams();
    const [loading, setLoading] = useState(false);
    const [guidData, setGuidData] = useState({});
    const [load, setLoad] = useState(false);
    const [unAvailableDate, setUnAvailableDate] = useState(null);
    const [dateToDelete, setDateToDelete] = useState('');
    const [deleteModal, setDeleteModal] = useState(false);

    const refresh = () => {
        setLoad(!load);
    };

    useEffect(() => {
        fetchOrgGuideDetails(guideId, setGuidData, setLoading);
    }, [load]);

    const context = {
        role: 'org',
        flow: 'guide'
    };

    const addUnavailableDate = async () => {
        if (!unAvailableDate) {
            toast.error('Please select unavailable date');
            return;
        }
        setLoading(true);
        const unavailableDate = unAvailableDate.toISOString();
        try {
            const newDate = await orgGuideUnavailableDateFun(
                {
                    tourId: guideId,
                    date: unavailableDate
                },
                'add'
            );
            if (newDate.status === 200) {
                toast.success('Successfully added new date');
                setUnAvailableDate(null);
                refresh();
            }
            setLoading(false);
        } catch (error) {
            setLoading(false);
            errorHandle(error);
        }
    };

    const deleteUnavailableDate = async () => {
        try {
            setLoading(true);
            const response = await orgGuideUnavailableDateFun({ tourId: guideId, date: dateToDelete }, 'remove');
            if (response.status === 200) {
                setLoading(false);
                toast.success('Date deleted successfully');
                setDeleteModal(false);
                refresh();
            }
        } catch (err) {
            setLoading(false);
            errorHandle(err);
        }
    };

    return (
        <div>
            {loading && (
                <div className='loadingBackground'>
                    <ReactLoading type='spin' color='#006aff' className='loadingSpin' />
                </div>
            )}
            <button className='backBtn' onClick={() => navigate('/org/g/my-guide')}>
                <img src={BackIcon} alt='back' /> Back to Guides
            </button>
            {Object.keys(guidData).length !== 0 && (
                <div className='orgTripDetailsLayout'>
                    <div className='tripDetailsMainRow'>
                        <div className='tripDetailsLeft'>
                            <GuidHeaderDetails guidData={guidData} />

                            <DetailsImageDisplay imageData={guidData?.images || []} />
                            <DetailsTab
                                context={context}
                                data={guidData}
                                whichSection={'org'}
                                deleteUnavailableDate={deleteUnavailableDate}
                                setDateToDelete={setDateToDelete}
                                deleteModal={deleteModal}
                                setDeleteModal={setDeleteModal}
                                loading={loading}
                                type={'act'}
                                refresh={refresh}
                            />
                        </div>
                        <div className='tripDetailsBookingUser'>
                            <OrgSlotTab data={guidData} type='gu' addTimeSlot={orgAddTimeSlot} refresh={refresh} />
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

export default OrgGuidDetails;
